module.exports = __webpack_public_path__ + "img/batchReportIcon.7dd1f468.png";